import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { EventService } from '../../../core/services/event.service';
import { NgForm } from '@angular/forms';
import * as _ from "lodash";
import {Angulartics2} from "angulartics2";

@Component({
    selector: 'main-tab-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['../profile.page.scss']
})
export class PhoneComponent implements OnInit {
    @Output() onFormAdd = new EventEmitter();
    @Input() dictData: any;
    form: NgForm;

    model: any;
    state: any = {
        isSubmitted: false
    };

    isCreation: boolean;
    isFormVisible: boolean = false;
    editModel: any;

    @ViewChild('form') set content(content: NgForm) {
        this.form = content;
    }

    constructor(
        private eventService: EventService,
        private http: HttpClient,
        private toastr: ToastrService,
        private angulartics2: Angulartics2
    ) {}

    ngOnInit() {
        this.convertToModels(this.eventService.selectedEvent.gql);
        this.eventService.onEventChange.subscribe(event => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
        this.eventService.onGqlReload.subscribe(() => {
            this.convertToModels(this.eventService.selectedEvent.gql);
        });
    }

    convertToModels(gqlRes) {
        let constituent = gqlRes.Participant[0].individualConstituent;
        this.model = {
            phones: []
        };

        constituent.constituentPhones.forEach(phone => {
            this.model.phones.push({
                constituentPhoneID: phone.constituentPhoneId,
				//Not a great fix - Really, the regex that accepts the phone number should be updated - Additionally, this doesn't handle international numbers
                phoneNumber:
					(phone.areaCode ? '(' + phone.areaCode + ') ' : '') + ((phone.phoneNumber && phone.phoneNumber.length >= 7) ? (phone.phoneNumber.substring(phone.phoneNumber.length - 7, phone.phoneNumber.length - 4) + '-' + phone.phoneNumber.substring(phone.phoneNumber.length - 4, phone.phoneNumber.length)): ''),
                phoneType: {
                    constituentPhoneTypeID: phone.phoneType.cmgmtPhoneTypeId,
                    name: phone.phoneType.name,
                    description: phone.phoneType.description
                },
                primary: phone.primaryFl
            });
        });
    }

    /** Edit/create **/
    cancel() {
        this.isFormVisible = false;
        this.editModel = null;
        this.state.isSubmitted = false;
    }

    create() {
        this.isCreation = true;
        this.isFormVisible = true;
        this.editModel = {
            phoneType: {},
            primary: false
        };
        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    edit(phone) {
        this.isCreation = false;
        this.isFormVisible = true;
        this.editModel = _.cloneDeep(phone);

        setTimeout(() => {
            this.onFormAdd.emit(this.form);
        }, 1);
    }

    validatePrimaryPhone() {
       if (this.editModel.primary) {
          return true;
       }
       let hasPrimaryPhone: boolean = false;

       this.model.phones.forEach(phone => {
           if (phone.constituentPhoneID != this.editModel.constituentPhoneID) {
               if (phone.primary) {
                 hasPrimaryPhone = true;
               }
           }
       });

       return hasPrimaryPhone;
    }

    save() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;

        if (!this.validatePrimaryPhone()) {
            this.toastr.error("There should be a primary phone set");
            return;
        }

        this.form.form.markAsPristine();
        if (this.isCreation) {
            this.http.post('/api/v1/user/phones', this.editModel)
                .subscribe(res => {
                    this.eventService.getPhones(true).subscribe(() => {});
                    this.toastr.success('Phone added.');
                    this.angulartics2.eventTrack.next({
                        action: 'Add Phone',
                        properties: {category: 'Profile'}
                    });
                }, err => {
					this.toastr.error("There was a problem creating the phone number");
				});
        } else {
            this.http.post('/api/v1/phones/' + this.editModel.constituentPhoneID, this.editModel)
                .subscribe(res => {
                    this.eventService.getPhones(true).subscribe(() => {});
                    this.toastr.success('Phone updated.');
                }, err => {
					this.toastr.error("There was a problem updating the phone number");
				});
        }
        this.isFormVisible = false;
        this.state.isSubmitted = false;
    }

    delete(phone) {
        this.http.delete('/api/v1/phones/' + phone.constituentPhoneID)
            .subscribe(res => {
                this.eventService.getPhones(true).subscribe(() => {});
                this.toastr.success('Phone deleted.');
                this.angulartics2.eventTrack.next({
                    action: 'Delete Phone',
                    properties: {category: 'Profile'}
                });
            });
    }
}

